import { Component } from '@angular/core';

@Component({
  selector: 'abc-large-row',
  templateUrl: './abc-large-row.component.html',
  styleUrls: ['./abc-large-row.component.css']
})
export class AbcLargeRowComponent{

  constructor() { }

}
